<template>
    <div :id="'About--' + merchant.id"
         class="item pb-3 mb-5 border-bottom">

        <loader v-if="fetchingData"></loader>

        <div v-else >
            <transition mode="out-in" name="slide">

                <div v-if="!isEdit" class="no-gutters">
                        <div class="col-12">
                            <h2>{{ merchant.headline }}</h2>
                        </div>

                        <div>
                            <p class="col-12" v-html="merchant.description"></p>
                        </div>

                        <buttons :disableDelete="true"
                                 :isLoading="submitting"
                                 @edit="isEdit = true"></buttons>
                </div>


                <buero-form
                    v-if="isEdit"
                    :elementValues="this.merchant"
                    :schema="schema"
                    method="patch"
                    url="/api/merchant/about"
                    @cancel="cancelEdit"
                    @updateItem="updateItem"></buero-form>
            </transition>
        </div>
    </div>
</template>

<script>
import {Form} from './Form';

export default {
    name: 'About',
    data() {
        return {
            fetchingData: true,
            submitting: false,
            merchant: Object,
            schema: (new Form()).schema(),
            isEdit: false,
        };
    },
    created: function() {
        axios.get('/api/merchant/about').then((response) => {
            this.merchant = response.data;
            this.fetchingData = false;
        }).catch((errors) => {
            this.$swal({
                icon: 'error',
                title: 'Die Daten konnten nicht geladen werden',
            });
            this.fetchingData = false;
        });
    },

    methods: {
        updateItem(payload) {
            this.merchant = payload;
            this.isEdit = false;
        },
        cancelEdit() {
            this.isEdit = false;
        },
    },
};
</script>

<style scoped>

</style>
